import { Component, ViewChild } from '@angular/core';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';
import { Pagination } from 'app/shared/pagination';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';
import { ModalEditLabourComponent } from '../modal-edit-labour/modal-edit-labour.component';
import { MySQLDateToISOPipe } from 'app/shared/mysql-date-to-iso.pipe';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

declare const Mangler: any;

@Component({
	selector: 'modal-bulk-edit-task',
	templateUrl: './modal-bulk-edit-task.component.html'
})
export class ModalBulkEditTaskComponent extends UIModalBaseComponent {

	@ViewChild(ModalEditLabourComponent) editLabourModal: ModalEditLabourComponent;

	step = 'operation';
	type = 'quote';
	list = null;
	operation = null;
	selectedTasks = [];
	project_id = null;
	quoteSelected = null;
	pagination = new Pagination();
	data = null;
	users = [];
	user_labour_mapping = {};
	userSelected = null;

	tabNewSO = { id: 'new_sales_order', description: 'New Sales Order', done: false };
	tabExistingSO = { id: 'existing_sales_order', description: 'Existing Sales Order', done: false };
	tabSelectSO = { id: 'select_so', description: 'Select Sales Order', done: false };
	tabExistingQuote = { id: 'existing_quote', description: 'Existing Quote', done: false };
	tabSelectQuote = { id: 'select_quote', description: 'Select Quote', done: false };
	tabLabourMapping = { id: 'map_labour_types', description: 'Labour Type Mapping', done: true };

	tabs = [];
	tab = null;

	disabled = false;

	constructor(
		public app: AppService,
		private api: ApiService,
		private datePipe: DatePipe,
		private router: Router
	) {
		super();
	}

	open(data: any) {
		this.disabled = false;
		this.selectedTasks = data.list || [];
		this.project_id = data.project_id || null;
		if (!this.project_id) return;
		this.resetParameters();
		this.validateTabs();
		this.getWorkedUsersFromTask();
		this.modal.open();
	}

	resetParameters() {
		this.step = 'operation';
		this.type = 'quote';
		this.data = null;
		this.tabs = [];
		this.tab = null;
		this.userSelected = null;
		this.user_labour_mapping = {};
		this.quoteSelected = null;
		this.list = null;
		this.operation = null;
	}

	getWorkedUsersFromTask() {
		this.users = [];
		this.api.task.getActiveWorkingUsers({
			task: this.selectedTasks
		}, data => {
			this.users = data;
			this.users.forEach(user => {
				this.user_labour_mapping[user.user_id] = {
					labour_type: null
				};
			});
		}, error => {
			this.app.notifications.showDanger(error.message);
		});
	}

	selectTab(tab) {
		const selectedTab = this.tabs.find(t => t.id === tab.id);
		if (!selectedTab) return;

		this.tab = selectedTab;
		this.step = this.getStepForTab(tab.id);
		this.validateTabs();

		this.activateStep();
	}

	getStepForTab(tabId: string): string {
		switch (tabId) {
			case 'new_sales_order':
			case 'existing_sales_order':
			case 'existing_quote':
				this.quoteSelected = null;
				return 'operation';
			case 'select_so':
				return 'select_sales_order';
			case 'select_quote':
				return 'select_quote';
			case 'map_labour_types':
				return 'map_labour_types';
			default:
				return 'operation';
		}
	}

	validateTabs() {
		this.tabNewSO.done = true;
		this.tabExistingSO.done = true;
		this.tabExistingQuote.done = true;
		this.tabSelectSO.done = !!this.quoteSelected;
		this.tabSelectQuote.done = !!this.quoteSelected;

		this.tabLabourMapping.done = true;
		for (const userId in this.user_labour_mapping) {
			if (!this.user_labour_mapping[userId]?.labour_type) {
				this.tabLabourMapping.done = false;
				break;
			}
		}

		this.tabs.forEach(t => { if (!t.done) this.tabLabourMapping.done = false; });
	}

	canGoBack() {
		return this.step !== 'operation';
	}

	setOperation(op) {
		this.operation = op;
		this.goToNextStep();
	}

	goToNextStep() {
		if (!this.operation) {
			this.step = 'operation';
		} else {
			switch (this.step) {
				case 'operation':
					switch (this.operation) {
						case 'existing_sales_order': this.step = 'select_sales_order';
							this.tabs = [];
							this.tabs.push(this.tabExistingSO);
							this.tabs.push(this.tabSelectSO);
							this.tabs.push(this.tabLabourMapping);
							this.tab = this.tabSelectSO;
							this.validateTabs();
							break;
						case 'new_sales_order': this.step = 'map_labour_types';
							this.tabs = [];
							this.tabs.push(this.tabNewSO);
							this.tabs.push(this.tabLabourMapping);
							this.tab = this.tabLabourMapping;
							this.validateTabs();
							break;
						case 'existing_quote': this.step = 'select_quote';
							this.tabs = [];
							this.tabs.push(this.tabExistingQuote);
							this.tabs.push(this.tabSelectQuote);
							this.tabs.push(this.tabLabourMapping);
							this.tab = this.tabSelectQuote;
							this.validateTabs();
							break;
						default: this.step = 'map_labour_types'; break;
					}
					break;
			}
		}

		this.activateStep();
	}

	goToPreviousStep() {
		if (this.step === 'operation') return;

		switch (this.step) {
			case 'confirm':
				switch (this.operation) {
					case 'existing_sales_order': this.step = 'select_sales_order'; break;
					case 'new_sales_order': this.step = 'map_labour_types'; break;
					case 'existing_quote': this.step = 'select_quote'; break;
					default: this.step = 'operation'; break;
				}
				break;

			default:
				this.step = 'operation';
				break;
		}

		this.activateStep();
	}

	isItemSelected(item) {
		return this.quoteSelected && item.id === this.quoteSelected.id;
	}

	activateStep() {
		switch (this.step) {
			case 'operation':
				this.operation = null;
				this.tabs = [];
				break;

			case 'select_sales_order':
				this.type = 'sales_order';
				this.fetchQuotes(1);
				break;

			case 'select_quote':
				this.type = 'quote';
				this.fetchQuotes(0);
				break;

			case 'map_labour_types':
				this.fetchLabourTypes(null);
				break;
		}
	}

	fetchLabourTypes(newLabourId) {
		this.api.quote.fetchLabourTypes(data => {
			this.data = data;
			this.compositeLabourData();
			if (newLabourId && this.userSelected) this.user_labour_mapping[this.userSelected.user_id] = { labour_type: newLabourId };
		}, error => {
			this.app.notifications.showDanger(error.message);
		});
	}

	addNewLabourType(userSelected) {
		this.userSelected = userSelected;
		this.editLabourModal.open({ id: 'new' });
	}

	editLabourModalClosed(data) {
		if (data?.id) this.fetchLabourTypes(data.id);
	}

	compositeLabourData() {
		this.data.pick_labour_categories.forEach(c => c.types = []);
		const cIndex = Mangler.index(this.data.pick_labour_categories, 'id');
		const unassigned = { id: 0, description: 'Unassigned', types: [] };
		cIndex[0] = unassigned;
		this.data.pick_labour_types.forEach(t => {
			const c = cIndex[t.category_id || 0] || cIndex[0];
			c.types.push(t);
		});
		if (unassigned.types.length) this.data.pick_labour_categories.push(unassigned);
	}

	fetchQuotes(sales_order = 1) {
		this.list = null;
		this.api.quote.list({
			project: this.project_id,
			sales_order,
			stage: ['in_progress']
		}, data => {
			this.list = data.list;
		}, error => {
			this.app.notifications.showDanger(error.message);
		});
	}

	selectItem(item) {
		this.quoteSelected = item;
		this.tab = this.tabLabourMapping;
		this.validateTabs();
		this.step = 'map_labour_types';
		this.activateStep();
	}

	stageColor(stage, selected = true, defaultColor = 'secondary') {
		if (!selected) return defaultColor;

		switch (stage) {
			case 'all': return 'primary';
			case 'active': return 'primary';
			case 'archived': return 'primary';
			case 'cancelled': return 'danger';
			case 'in_progress': return 'secondary';
			case 'in_review': return 'warning';
			case 'passed_review': return 'info';
			case 'sent': return 'purple';
			case 'accepted': return 'success';
			case 'complete': return 'success';
		}
		return 'secondary';
	}

	stageDescription(stage) {
		switch (stage) {
			case 'all': return 'All';
			case 'active': return 'Active';
			case 'archived': return 'Archived';
			case 'cancelled': return 'Cancelled';
			case 'in_progress': return 'In Progress';
			case 'in_review': return 'In Review';
			case 'passed_review': return 'Passed Review';
			case 'sent': return 'Sent';
			case 'accepted': return 'Accepted';
			case 'complete': return 'Complete';
		}
		return '';
	}

	formattedSQLDate(date) {
		const d = MySQLDateToISOPipe.stringToDate(date);
		return `Sent: ${this.datePipe.transform(d, 'shortDate')}`;
	}

	submitButton() {
		if (this.tabLabourMapping.done) {
			const data = {
				tasks: this.selectedTasks,
				quote_id: this.quoteSelected ? this.quoteSelected.id : null,
				user_labour_mapping: this.user_labour_mapping,
				project_id: this.project_id
			};

			this.disabled = true;
			this.api.task.addBillableTaskToQuote(data, result => {
				this.router.navigate(['/' + this.app.org, 'quote', result]);
				this.app.navigation.refreshBillableTaskCount();
			}, error => {
				this.disabled = false;
				this.app.notifications.showDanger(error.message);
			});
		}
	}

}
